import { Component, OnInit, Output, EventEmitter, Input, ViewChild, ElementRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Ingreso, Mercaderia } from 'src/app/model/index.model';
import { MercaderiaService } from 'src/app/service/index.service';
import { parse } from 'url';
import { FilMercaderiaComponent } from '../../filtro/fil-mercaderia/fil-mercaderia.component';
import { Modal } from 'bootstrap'; // asegúrate de tener bootstrap JS importado
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-cb-mercaderia-2',
  templateUrl: './cb-mercaderia-2.component.html',
  styleUrls: ['./cb-mercaderia-2.component.css']
})
export class CbMercaderia2Component implements OnInit {

  @ViewChild("txtcode", { static: false }) txtcode: ElementRef;
  @ViewChild("lunch", { static: false }) lunch: ElementRef;
  @ViewChild('modalContent', { static: false }) modalContent: any;


  @ViewChild(FilMercaderiaComponent, { static: false }) fil: FilMercaderiaComponent;


  @Output() select = new EventEmitter<Mercaderia>();
  @Input() require

  item: Mercaderia;
  items: Mercaderia[];
  focus: boolean = false;
  private modalRef: NgbModalRef;


  codigo: string;

  public entity = "Mercaderia";

  focusss() {

    // Abro el modal primero
    this.modalRef = this.modalService.open(this.modalContent, { size: 'lg' });
    // Espero un tick de Angular para que se renderice el modal
    setTimeout(() => {
      if (this.fil) {
        this.fil.search = this.codigo;
        this.fil.list();
        this.fil.focusable();
      }
    }, 100);

  }
  onKeyDown(event: KeyboardEvent) {
    console.log(event)
    if (event.key == 'F2') {
      console.log("ss")
      this.focusss();
      event.preventDefault();
    }
  }


  constructor(private wsdl: MercaderiaService, private modalService: NgbModal) {

  }

  ngOnInit() {

  }

  @Input()
  set dibujar(item: Mercaderia) {
    if (item != undefined) {
      this.item = item;
    } else {
      this.item = new Mercaderia();
      this.item.nombre = ""
      this.codigo = "";
    }
  }

  @Input()
  foco(b: Boolean) {

    if (b) {
      this.item = new Mercaderia();
      this.item.nombre = ""
      this.codigo = "";
      this.txtcode.nativeElement.focus();
    }
  }

  compareFn(c1: Mercaderia, c2: Mercaderia): boolean {
    return c1 && c2 ? c1.id === c2.id : c1 === c2;
  }


  async filter(f: NgForm) {
    if (f.valid) {
      let fiambre = false
      let precioFiambre;
      console.log('ss', this.codigo.substring(0, 3))
      if (this.codigo.substring(0, 3) == '200') {
        /* aca tendriamos que cambiar la logica */
        fiambre = true;
        precioFiambre = parseFloat(this.codigo.substring(7, 10) + '.' + this.codigo.substring(10, 13)).toFixed(2)
        this.codigo = this.codigo.substring(0, 7)

      }

      let data = await this.wsdl.doFindCode(this.codigo).then()
      let res = JSON.parse(JSON.stringify(data));
      if (res.code == 200) {
        this.item = new Mercaderia();
        if (res.data) {
          this.item = res.data;
          if (fiambre) {
            this.item.precioCon = precioFiambre
            this.item.precioDeb = precioFiambre
            this.item.precioLis = precioFiambre
            this.item.precioCom = parseFloat(precioFiambre) / 1.17
          }
          console.log(this.item.precioCom)
          this.select.emit(this.item);
        } else {
          this.item = new Mercaderia();
          this.item.nombre = "no se encontro producto";
        }
      } else {
        this.item = new Mercaderia();
        this.item.nombre = "no se encontro producto";

      }

    } else {
      alert('Validar');
    }
  }

  /* filtro customer */

  doFound(event: Mercaderia[]) {
    this.items = event;
  }

  selected(item) {
    this.codigo = item.serie
    this.select.emit(item);
    if (this.modalRef) {
      this.modalRef.close(); // ✅ cierra bien el modal
    }
  }

}

